<div class="modal-header">
    <h4 class="modal-title">Resumen de inventario por sucursal</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        <div class="row col-md-6">
            <div class="col-md-6">
                <app-generic-autocomplete
                    [dataSource]="medios"
                    (selectedValueChange)="medioSelected($event)"
                    placeholder="Medio"
                    displayField="nombre">
                </app-generic-autocomplete>
            </div>
            <div class="col-md-6">
                <app-generic-autocomplete
                    [dataSource]="elementos"
                    (selectedValueChange)="popSelected($event)"
                    [disabled]="!medio_sel"
                    placeholder="Elemento POP"
                    displayField="nombre">
                </app-generic-autocomplete>
            </div>
        </div>

        <div class="mt-4" [hidden]="!(dsstoreFile.data.length > 0)">
            <div class="promo-container mat-elevation-z0 table-responsive text-nowrap" style="max-height: 60vh; overflow-y: auto; padding: 10px; border: 1px solid #ccc;">
                <table mat-table [dataSource]="dsstoreFile" matSort #sortSuc="matSort" class="" style="width: 100%;">

                    <ng-container *ngFor="let column of displayedColumnsStore; let i = index">
                        <ng-container [matColumnDef]="column">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="custom-header" style="min-width: 190px;">
                                <div class="header-wrapper">
                                    <div class="header-title">{{column}}</div>
                                    <mat-form-field appearance="outline" class="filter-input" (click)="$event.stopPropagation()">
                                        <mat-label><mat-icon>search</mat-icon></mat-label>
                                        <input *ngIf="column !== 'Plaza'" matInput (keyup)="applyColumnFilter(column, $event)">
                                        <mat-select *ngIf="column === 'Plaza'" (selectionChange)="applyColumnFilterSelect(column, $event.value)" name="plaza">
                                            <mat-option [value]="''">Todas</mat-option>
                                            <mat-option *ngFor="let p of plazasList" [value]="p">{{ p }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let store"> {{store[column]}} </td>
                        </ng-container>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsStore"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsStore;"></tr>
                </table>
                <mat-paginator #paginatorSuc [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
            </div>
        </div>

        <div *ngIf="dsstoreFile.data.length === 0" class="text-center p-5 mt-4 border rounded bg-light">
            <mat-icon class="text-muted" style="font-size: 48px; width: 48px; height: 48px;">info_outline</mat-icon>
            <p class="mt-3 text-muted">
                Seleccione un <strong>Medio</strong> y un <strong>Elemento POP</strong> para visualizar el resumen de inventario.
            </p>
        </div>

    </div>
</mat-dialog-content>